import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 * Overwrites obj1's values with obj2's and adds
 * obj2's if non existent in obj1
 * @returns obj3 a new object based on obj1 and obj2
 */
export function mergeOptions(obj1, obj2) {
  var obj3 = {};
  for (var attr1 in obj1) obj3[attr1] = obj1[attr1];
  for (var attr2 in obj2) obj3[attr2] = obj2[attr2];
  return obj3;
}
export function assert(condition) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Assertion failed';
  if (!condition) {
    if (typeof Error !== 'undefined') throw new Error(message);
    throw message; // Fallback
  }
}

/**
 * Does str contain test?
 * @param {String} str_test
 * @param {String} str
 * @returns Boolean
 */
export function contains(str_test, str) {
  return !!~str.indexOf(str_test);
}
export function getUniqueId() {
  return "_".concat(Math.random().toString(36).substr(2, 9));
}
export function isDefAndNotNull(val) {
  // Note that undefined == null.
  return val != null; // eslint-disable-line no-eq-null
}
export function assertEqual(a, b, message) {
  if (a !== b) {
    throw new Error("".concat(message, " mismatch: ").concat(a, " != ").concat(b));
  }
}
export function now() {
  // Polyfill for window.performance.now()
  // @license http://opensource.org/licenses/MIT
  // copyright Paul Irish 2015
  // https://gist.github.com/paulirish/5438650
  if ('performance' in window === false) {
    window.performance = {};
  }
  Date.now = Date.now || function () {
    // thanks IE8
    return new Date().getTime();
  };
  if ('now' in window.performance === false) {
    var nowOffset = Date.now();
    if (performance.timing && performance.timing.navigationStart) {
      nowOffset = performance.timing.navigationStart;
    }
    window.performance.now = function () {
      return Date.now() - nowOffset;
    };
  }
  return window.performance.now();
}
export function randomId(prefix) {
  var id = now().toString(36);
  return prefix ? prefix + id : id;
}
export function isNumeric(str) {
  return /^\d+$/.test(str);
}
export function isEmpty(str) {
  return !str || 0 === str.length;
}
export function emptyArray(array) {
  while (array.length) array.pop();
}
export function anyMatchInArray(source, target) {
  return source.some(function (each) {
    return target.indexOf(each) >= 0;
  });
}
export function everyMatchInArray(arr1, arr2) {
  return arr2.every(function (each) {
    return arr1.indexOf(each) >= 0;
  });
}
export function anyItemHasValue(obj) {
  var has = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var keys = Object.keys(obj);
  keys.forEach(function (key) {
    if (!isEmpty(obj[key])) has = true;
  });
  return has;
}